module.exports = __webpack_public_path__ + "static/media/logo.78a24a6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = 167
// module chunks = 0